// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApi as SessionApi,
  DefaultApiChangeLanguageRequest as SessionApiChangeLanguageRequest,
} from '@eih-netbroker/api-session';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config/config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

export type ChangeLanguageRequest = Omit<SessionApiChangeLanguageRequest, keyof ResourceHeadersWithToken>;

export class SessionResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'SessionResource';
  private sessionApi: SessionApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.session}`, configApi);
    this.sessionApi = new SessionApi(
      new Configuration({ basePath: `${basePath}${configApi.usUrl.session}` }),
      `${basePath}${configApi.usUrl.session}`,
      axiosInstance,
    );
  }

  async sessionInit(headers: ResourceHeadersWithToken) {
    return this.sessionApi.sessionInit({ ...headers });
  }

  async deleteSession(headers: ResourceHeadersWithToken) {
    return this.sessionApi.deleteSession(headers);
  }

  async changeLanguage(request: ChangeLanguageRequest, headers: ResourceHeadersWithToken) {
    return this.sessionApi.changeLanguage({ ...request, ...headers });
  }

  async updateSessionToken(headers: ResourceHeadersWithToken, newToken: string) {
    return this.sessionApi.updateSessionToken(headers, {
      headers: { Authorization: `Bearer ${newToken}` },
    });
  }

  async getUssVersions(headers: ResourceHeadersWithToken) {
    return this.sessionApi.getUSSVersions(headers);
  }

  getVersion() {
    return this.sessionApi.getVersion();
  }
}
